// API Configuration
// This file handles different API URLs for development vs production

const config = {
  // For local development
  development: {
    apiUrl: 'http://localhost:5001'
  },
  // For production (AWS Lambda)
  production: {
    apiUrl: process.env.REACT_APP_API_URL || 'https://vvcheqvz8h.execute-api.us-east-1.amazonaws.com/prod'
  }
};

const environment = process.env.NODE_ENV || 'development';

export const API_URL = config[environment].apiUrl;

const appConfig = {
  API_URL
};

export default appConfig;
